import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import { ClientInput } from "../../types/clientInput.types";
import { replyClientInput } from "../../Api/ApiUrlConst";
import { useAuth } from "../../Context/AuthContext";

interface Props {
  input: ClientInput;
  onReplySuccess: () => void;
}

const ClientInputThread: React.FC<Props> = ({
  input,
  onReplySuccess
}) => {
  const [reply, setReply] = useState("");
  const { role } = useAuth();

  const sendReply = async () => {
    if (!reply.trim()) return;

    await replyClientInput({
      clientInputId: input.id,
      message: reply
    });

    setReply("");
    onReplySuccess();
  };

  return (
    <div className="border rounded p-2 mb-3">
      <div className="fw-bold">📝 {input.message}</div>

      <small className="text-muted">
        {new Date(input.createdAt).toLocaleString()}
      </small>

      <div className="mt-2 ms-3">
        {input.replies.map(r => (
          <div key={r.id}>↳ {r.message}</div>
        ))}
      </div>

      {role === "Client" && (
        <div className="d-flex gap-2 mt-2">
          <Input
            value={reply}
            onChange={e => setReply(e.target.value)}
            placeholder="Reply..."
          />
          <Button size="sm" onClick={sendReply}>
            Send
          </Button>
        </div>
      )}
    </div>
  );
};

export default ClientInputThread;
